import React from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "./CartContext"; 
import { Basket3 } from "react-bootstrap-icons";
import BBSButton from "../ui/BBSButton";

const CartBadge = () => {
  const { cartItems } = useCart();
  const navigate = useNavigate();

  const itemCount = cartItems.length;

  return (
    <BBSButton
      onClick={() => navigate("/Checkout")}
      // Wir fügen 'cart-badge-btn' hinzu, um ihn im CSS gezielt anzusprechen
      className="p-1 ps-2 pe-2 d-flex bg-bbs-cart align-items-center shadow-sm"
      style={{ cursor: "pointer" }}
      aria-label={`${itemCount} Bewerbungen im Einkaufswagen`}
      title="Zur Bewerbungsliste wechseln"
    >
      {/* Container für das Icon und die innenliegende Zahl */}
      <div className="position-relative d-inline-block me-2">
        {/* Das Einkaufswagen-Icon in Anthrazit/Dunkelgrau für den modernen Look */}
        <Basket3 size={24} className="text-white" style={{ opacity: 0.85 }} />
        
        {/* Die Zahl, exakt positioniert IM Einkaufswagen wie bei Amazon */}
        <span 
          className="position-absolute text-dark" 
          style={{
            top: "11px",          // Schiebt die Zahl vertikal in den Korb
            left: "46%",         // Zentriert die Zahl horizontal
            transform: "translateX(-45%)", // Feinjustierung für die optische Mitte
            fontSize: "0.70rem",  // Perfekte Größe für ein- oder zweistellige Zahlen
            zIndex: 1
          }}
        >
          {itemCount}
        </span>
      </div>

      {/* Text daneben, genau wie im Screenshot */}
      <span className="text-white small mb-0 ms-0" style={{ fontSize: "0.95rem" }}>
        Bewerbungskorb
      </span>
    </BBSButton>
  );
};

export default CartBadge;